import questionsList from "./questionsList"
export default questionsList;
